import React from 'react';

import clsx from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    AppleIcon,
    AndroidIcon,
} from 'wanderu-components';
import { localize, selectLocale } from 'wanderu-i18n';

import { sendEvent } from './events';

import styles from './DownloadIcons.scss';

const APPLE_STORE_URL = 'https://apps.apple.com/app/apple-store/id962532589?pt=117125988&ct=web-search_widget&mt=8';
const GOOGLE_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.wanderu.wanderu&utm_source=web&utm_campaign=web-search_widget';

function DownloadIcons(props) {
    const {
        className = '',
        t,
    } = props;

    return (
        <span className={clsx(
            className,
            styles.icons,
        )}>
            <a href={APPLE_STORE_URL} onClick={() => sendEvent('ios')} rel="noreferrer" target="_blank">
                <AppleIcon
                    alt={t('apple-phone-icon')}
                    className={styles.icon}
                />
            </a>
            <a className={styles.androidIcon} href={GOOGLE_PLAY_STORE_URL} onClick={() => sendEvent('android')} rel="noreferrer" target="_blank">
                <AndroidIcon
                    alt={t('android-phone-icon')}
                    className={styles.icon}
                />
            </a>
        </span>
    );
}

DownloadIcons.propTypes = {
    className: PropTypes.string,
    t: PropTypes.func,
};

export { DownloadIcons };

function mapStateToProps(state) {
    return {
        locale: selectLocale(state),
    };
}
export default connect(mapStateToProps)(localize(DownloadIcons, ['t']));
